/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import api from '@/api';

export const namespaced = true;

export const state = {
  user: {},
  insightlyUser: {},
};

export const actions = {
  setAccessToken({ commit }, accessToken) {
    return commit('SET_ACCESS_TOKEN', accessToken);
  },
  setUser({ commit }, user) {
    return commit('SET_USER', user);
  },
  fetchInsightlyUser({ commit }, email) {
    return api.get(`/users/${email}`)
      .then((response) => {
        commit('SET_INSIGHTLY_USER', response.data);
      }).catch((exception) => {
        console.error(exception);
      });
  },
};

export const mutations = {
  SET_ACCESS_TOKEN(state, accessToken) {
    state.accessToken = accessToken;
  },
  SET_USER(state, user) {
    state.user = user;
  },
  SET_INSIGHTLY_USER(state, insightlyUser) {
    state.insightlyUser = insightlyUser;
  },
};

export const getters = {
  getCurrentUser: () => state.user,
};
